import api from '@/api';

import { PageResult } from '@/core/request/PageResult';

import {
  ListSubGroupsQuery,
  SubGroup,
  SubGroupByGroup,
  SubGroupByGroupList,
  UpdateSubGroupRequest,
} from './SubGroups.types';

import { API_BASE_URL } from '..';
import { ListResult } from '@/core/request/ListResult';

const CONTROLLER_URL = `${API_BASE_URL}/subgroups`;

export async function listSubGroups(
  params?: ListSubGroupsQuery,
): Promise<ListResult<SubGroup>> {
  const result = (await api.get(`${CONTROLLER_URL}`, params)) as unknown;

  return result as PageResult<SubGroup>;
}

export async function listSubGroupsByGroups(
  groupId?: number,
): Promise<SubGroupByGroupList> {
  const result = (await api.get(
    `${CONTROLLER_URL}/group/${groupId}`,
    null,
  )) as unknown;

  return result as SubGroupByGroupList;
}

export async function deleteSubGroup(id: number) {
  const result = (await api.remove(
    `${CONTROLLER_URL}/${id}`,
    {},
    null,
  )) as unknown;

  return result;
}

export async function createSubGroup(obj: SubGroup): Promise<{
  id: number;
  name: string;
}> {
  const result = (await api.post(`${CONTROLLER_URL}`, obj, null)) as unknown;

  return result as SubGroupByGroup;
}

export async function updateSubGroup(
  obj: UpdateSubGroupRequest,
): Promise<SubGroupByGroup> {
  const result = (await api.put(`${CONTROLLER_URL}`, obj, null)) as unknown;

  return result as SubGroupByGroup;
}
